(() => {
  const MQ = window.matchMedia("(max-width: 699px)");
  const NAV_ID = "follow-phone-nav";
  const DETAILS_ID = "Details-menu-drawer-container";
  const OPEN = "follow-phone-nav-open";

  const navEl = () => document.getElementById(NAV_ID);
  const detailsEl = () => document.getElementById(DETAILS_ID);

  const mountOnBody = (el) => {
    if (el && el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
  };

  const behindEls = () => {
    const nodes = [
      document.getElementById("MainContent"),
      document.querySelector("footer"),
      document.querySelector(".footer-group"),
    ];
    return [...new Set(nodes.filter(Boolean))];
  };

  const setBehind = (on) => {
    for (const node of behindEls()) {
      node.inert = on;
      if (on) node.setAttribute("aria-hidden", "true");
      else node.removeAttribute("aria-hidden");
    }
  };

  const setOpen = (open) => {
    const el = navEl();
    if (!el) return;
    mountOnBody(el);
    const on = !!open && MQ.matches;
    el.hidden = !on;
    el.setAttribute("aria-hidden", on ? "false" : "true");
    if (on) {
      el.setAttribute("role", "dialog");
      el.setAttribute("aria-modal", "true");
    } else {
      el.removeAttribute("role");
      el.removeAttribute("aria-modal");
    }
    el.classList.toggle("is-open", on);
    document.documentElement.classList.toggle(OPEN, on);
    document.body.classList.toggle(OPEN, on);
    setBehind(on);
  };

  const detailsIsOpen = () => {
    const d = detailsEl();
    return !!(d && (d.hasAttribute("open") || d.classList.contains("menu-open")));
  };

  const sync = () => {
    if (!MQ.matches) {
      setOpen(false);
      return;
    }
    setOpen(detailsIsOpen());
  };

  const bindDetails = () => {
    const d = detailsEl();
    if (!d || d.dataset.followPhoneBound === "1") return;
    d.dataset.followPhoneBound = "1";
    d.addEventListener("toggle", sync);
    new MutationObserver(sync).observe(d, {
      attributes: true,
      attributeFilter: ["open", "class"],
    });
  };

  const boot = () => {
    mountOnBody(navEl());
    bindDetails();
    sync();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener(
    "click",
    (event) => {
      if (!MQ.matches) return;
      const t = event.target;
      if (!(t instanceof Element)) return;
      if (!t.closest(".follow-hamburger, .header__icon--menu, summary.header__icon--summary")) {
        return;
      }
      requestAnimationFrame(sync);
      setTimeout(sync, 0);
    },
    true
  );

  MQ.addEventListener("change", sync);
})();
